import { Component } from 'react';
// import { Routes, Route, HashRouter } from 'react-router-dom';
import { Routes, Route } from 'react-router-dom';
// import { I18nextProvider } from 'react-i18next';

import 'bootstrap/dist/css/bootstrap.min.css';

// import logo from './logo.svg';
import './App.css';

// import EventBus from './common/EventBus';

import IUser from './models/user.model';
import AuthService from './services/auth.service';

import ServiceTerms from './forms/serviceterms';
import PrivacyStatements from './forms/privacystatements';
import RegisterRequirement from './forms/register-requirement';
import Register from './forms/register';
import AccountVerification from './forms/account-verification';
import ResendVerification from './forms/resend-verification';
import RegisterSuccess from './forms/register-success';
import Signin from './forms/signin';
import ForgotUsername from './forms/forgot-username';
import ForgotUsernameSuccess from './forms/forgot-username-success';
import ForgotPassword from './forms/forgot-password';
import ForgotPasswordSuccess from './forms/forgot-password-success';
import ResetPassword from './forms/reset-password';
import ResetPasswordSuccess from './forms/reset-password-success';
import Home from './forms/home';
import Profile from './forms/profile';
import SpeedTest from './forms/speedtest';
import Admin from './forms/admin';

// import i18n from './assets/locales';

type Props = {};

type State = {
  // showModeratorBoard: boolean,
  // showAdminBoard: boolean,
  user: IUser | undefined,
  isAdmin: boolean
}

class App extends Component<Props, State> {
  constructor(props: Props) {
    super(props);

    document.title = 'SquareGolf Members';
    const viewport = document.createElement('meta');
    viewport.name = 'viewport';
    viewport.content = 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no, viewport-fit=cover';
    document.getElementsByTagName('head')[0].appendChild(viewport);

    // this.handleSignout = this.handleSignout.bind(this);

    this.state = {
      // showModeratorBoard: false,
      // showAdminBoard: false,
      user: undefined,
      isAdmin: false
    };
  }

  componentDidMount() {
    const user = AuthService.getCurrentUser();

    if (user) {
      this.setState({
        user: user,
        // showModeratorBoard: user.roles.includes('ROLE_MODERATOR'),
        // showAdminBoard: user.roles.includes('ROLE_ADMIN'),
      });
    }

    // EventBus.on('signout', this.handleSignout);
  }

  componentWillUnmount() {
    // EventBus.remove('signout', this.handleSignout);
  }

  // handleSignout() {
  //   // AuthService.signout();
  //   this.setState({
  //     // showModeratorBoard: false,
  //     // showAdminBoard: false,
  //     user: null,
  //     isAdmin: false
  //   });
  // }

  render() {
    // const {
    //   // user,
    //   // isAdmin,
    //   // showModeratorBoard,
    //   // showAdminBoard,
    // } = this.state;

    return (
      <>
        {/* <I18nextProvider i18n={i18n}> */}
        <div className='background'></div>
        <div className='container mt-5'>
          <Routes>
            <Route path='/' element={<Signin />} />
            <Route path='/home' element={<Home />} />
            <Route path='/terms' element={<ServiceTerms />} />
            <Route path='/privacy' element={<PrivacyStatements />} />
            <Route path='/account/register' element={<Register />} />
            <Route path='/account/register-requirement' element={<RegisterRequirement />} />
            <Route path='/account/verify/:uuid/:token' element={<AccountVerification />} />
            <Route path='/account/register-success' element={<RegisterSuccess />} />
            <Route path='/account/forgot-username' element={<ForgotUsername />} />
            <Route path='/account/forgot-username-success' element={<ForgotUsernameSuccess />} />
            <Route path='/account/forgot-password' element={<ForgotPassword />} />
            <Route path='/account/forgot-password-success' element={<ForgotPasswordSuccess />} />
            <Route path='/account/reset-password/:uuid/:token' element={<ResetPassword />} />
            <Route path='/account/reset-password-success' element={<ResetPasswordSuccess />} />
            <Route path='/signin/resend-verification' element={<ResendVerification />} />
            <Route path='/signin' element={<Signin />} />
            <Route path='/profile' element={<Profile />} />
            <Route path='/speedtest' element={<SpeedTest/>} />
            <Route path='/admin' element={<Admin />} />
          </Routes>
        </div>
        {/* </I18nextProvider> */}

        { /*<AuthVerify signOut={this.signOut}/> */ }
      </>
    );
  }
}

export default App;
